import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "call-content"
};
import TUICore, { TUIConstants } from '@tencentcloud/tui-core';
import TUIChatEngine from '@tencentcloud/chat-uikit-engine';
import { computed, ref } from '../../../adapter-vue';
import { JSONToObject } from '../../../utils/index';
import Icon from '../../../components/common/Icon.vue';
import callVideoSVG from '../../../assets/icon/call-video.svg';
import callVoiceSVG from '../../../assets/icon/call-voice.svg';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-call-c2c',
  props: {
    message: {
      type: Object,
      default: () => ({})
    },
    signalingInfo: {
      type: Object,
      default: () => ({})
    },
    customContent: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    var props = __props;
    var TYPES = ref(TUIChatEngine.TYPES);
    var isCallMessage = computed(() => props.signalingInfo != null);
    var callInfo = computed(() => {
      var _JSONToObject, _props$signalingInfo;
      var callType = (_JSONToObject = JSONToObject((_props$signalingInfo = props.signalingInfo) === null || _props$signalingInfo === void 0 ? void 0 : _props$signalingInfo.data)) === null || _JSONToObject === void 0 ? void 0 : _JSONToObject.call_type;
      switch (callType) {
        case 1:
          return {
            type: 1,
            icon: callVoiceSVG
          };
        case 2:
          return {
            type: 2,
            icon: callVideoSVG
          };
        default:
          break;
      }
      return {
        type: 0,
        icon: ''
      };
    });
    var conversationType = computed(() => {
      var _props$message;
      return (_props$message = props.message) === null || _props$message === void 0 ? void 0 : _props$message.conversationType;
    });
    var custom = computed(() => {
      var _props$customContent;
      return (_props$customContent = props.customContent) === null || _props$customContent === void 0 ? void 0 : _props$customContent.custom;
    });
    var callAgain = () => {
      if (conversationType.value === TUIChatEngine.TYPES.CONV_C2C) {
        var _props$message2, _props$message3, _props$message4, _callInfo$value;
        var userID = ((_props$message2 = props.message) === null || _props$message2 === void 0 ? void 0 : _props$message2.flow) === 'out' ? (_props$message3 = props.message) === null || _props$message3 === void 0 ? void 0 : _props$message3.to : (_props$message4 = props.message) === null || _props$message4 === void 0 ? void 0 : _props$message4.from;
        TUICore.callService({
          serviceName: TUIConstants.TUICalling.SERVICE.NAME,
          method: TUIConstants.TUICalling.SERVICE.METHOD.START_CALL,
          params: {
            userIDList: [userID],
            type: callInfo === null || callInfo === void 0 || (_callInfo$value = callInfo.value) === null || _callInfo$value === void 0 ? void 0 : _callInfo$value.type
          }
        });
      }
    };
    return (_ctx, _cache) => {
      return _unref(isCallMessage) && _unref(conversationType) === _unref(TYPES).CONV_C2C ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["call", ['call-' + _unref(conversationType), __props.message.flow === 'out' && 'call-reverse']]),
        onClick: callAgain
      }, [_createElementVNode("div", {
        class: _normalizeClass(['icon', __props.message.flow === 'out' && _unref(callInfo).type === 2 && 'icon-reverse'])
      }, [_createVNode(Icon, {
        file: _unref(callInfo).icon
      }, null, 8, ["file"])], 2), _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(custom)), 1)], 2)) : _createCommentVNode("", true);
    };
  }
});